"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultTransformRegistry_1 = require("./DefaultTransformRegistry");
var DataPointsQuery;
(function (DataPointsQuery) {
    DataPointsQuery.build = function (registry) {
        if (registry === void 0) { registry = DefaultTransformRegistry_1.DefaultTransformRegistry; }
        var calcNames = Object.keys(registry);
        var calculations = calcNames.reduce(function (calcs, calcName) {
            calcs[calcName] = 1;
            return calcs;
        }, {});
        return {
            v1: {
                calculations: calculations,
            },
        };
    };
})(DataPointsQuery = exports.DataPointsQuery || (exports.DataPointsQuery = {}));
//# sourceMappingURL=DataPointsQuery.js.map